import React from 'react';
import { Button, Col, Modal, ModalFooter, ModalBody, ModalHeader, Row } from 'reactstrap';
import Address from './Address';
import AddressTypes from './LookupDropDown';

class AddressInputModal extends React.Component {

    handleSave = () => {
        this.props.onSave();
        this.props.onToggle();
    }

    handleAddressChange = (name, value) => {
        const newPersonAddress = this.props.personAddress;
        newPersonAddress.address[name] = value;
        this.props.onChange(newPersonAddress);
    };

    handleAddressTypeOnChange = (e) => {
        const newPersonAddress = this.props.personAddress;
        newPersonAddress.addressTypeId = e.target.value;
        this.props.onChange(newPersonAddress);
    };

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.onToggle}
                size='lg'
            >
                <ModalHeader toggle={this.props.toggle}>Add / Edit Address</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <AddressTypes
                                label='Address Type'
                                name='addressTypeId'
                                lookups={this.props.addressTypes}
                                value={this.props.personAddress.addressTypeId}
                                onChange={this.handleAddressTypeOnChange}
                            />
                        </Col>
                    </Row>
                    <Address
                        {...this.props.personAddress.address}
                        onChange={this.handleAddressChange}
                        states={this.props.states}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSave}>Save</Button>{' '}
                    <Button color="secondary" onClick={this.props.onToggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AddressInputModal